import JobHeader from "./job_header";
import JobCgDetail from "./job_cg_details";
import { useEffect, useState } from "react";
import JobHighlights from "./job_hightlights";
import JobDescription from "./job_description";
import JobMoreInfo from "./job_more_info";
import { Alert, Col, Fade, Row, Spinner } from "reactstrap";
import CryptoJS from 'crypto-js';
import { fetchJobById } from "../../ts-lib/cg-job/features/Jobs/services/jobsAPI";

export default function JobRegistration() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [job, setJob] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [isSuccessVisibleFade, setIsSuccessVisibleFade] = useState(false);
    const [failMessage, setFailMessage] = useState("");
    const [isFailVisibleFade, setIsFailVisibleFade] = useState(false);
    const [hashJobId, setHashJobId] = useState("");

    const getJobDetails = async (jobId) => {
        const response = await fetchJobById(jobId);
        setJob(response)
        setIsLoading(false);
    }

    useEffect(() => {
        const params = (new URL(document.location)).searchParams;
        let jobId = params.get("jobId"); 
        jobId = jobId.replace(/ /g,"+");
        setHashJobId(jobId);
        const decrypted = CryptoJS.AES.decrypt(jobId, "CareConcierge");
        jobId = decrypted.toString(CryptoJS.enc.Utf8);
        getJobDetails(jobId);
    }, []);

    useEffect(() => {
        let countDown;
        if (isFailVisibleFade) {
            countDown = setInterval(() => {
            setFailMessage("Something went wrong. Please try again.");
            setIsFailVisibleFade(false);
            }, 5000);
        }

        return () => {
            if (countDown) clearInterval(countDown);
        };
    }, [isFailVisibleFade]);

    useEffect(() => {
        let countDown;
        if (isSuccessVisibleFade) {
            countDown = setInterval(() => {
            setIsSuccessVisibleFade(false);
            }, 5000);
        }

        return () => {
            if (countDown) clearInterval(countDown);
        };
    }, [isSuccessVisibleFade]);
    

    return (
        !isLoading ?
        <div className="job-container">
            <div className="fixed-top container" style={{marginTop: "15px", zIndex: "9999"}}>
                <Fade in={isSuccessVisibleFade}>
                <Alert
                    color="success"
                    isOpen={isSuccessVisibleFade}
                    toggle={() => setIsSuccessVisibleFade(false)}
                >
                    {successMessage}
                </Alert>
                </Fade>
                <Fade in={isFailVisibleFade}>
                <Alert
                    color="danger"
                    isOpen={isFailVisibleFade}
                    toggle={() => setIsFailVisibleFade(false)}
                >
                    {failMessage}
                </Alert>
                </Fade>
            </div>
            <JobHeader />
            <JobCgDetail 
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                job={job}
                setFailMessage={setFailMessage}
                setSuccessMessage={setSuccessMessage}
                setIsFailVisibleFade={setIsFailVisibleFade}
                setIsSuccessVisibleFade={setIsSuccessVisibleFade}
                setJob={setJob}
            />
            <Row style={{display:"flex", marginTop: 30, marginBottom: 30}}>
                <Col style={{maxWidth: 150, border: "#5A46AA 1px solid", padding: 5, borderRadius: 5, textAlign: 'center', marginRight: 30}}><a href={`/job_registration/?jobId=${hashJobId}#highlights`} className="j-tab">Highlights</a></Col>
                <Col style={{maxWidth: 150, border: "#5A46AA 1px solid", padding: 5, borderRadius: 5, textAlign: 'center', marginRight: 30}}><a href={`/job_registration/?jobId=${hashJobId}#info`} className="j-tab">Info</a></Col>
                <Col style={{maxWidth: 150, border: "#5A46AA 1px solid", padding: 5, borderRadius: 5, textAlign: 'center', marginRight: 30}}><a href={`/job_registration/?jobId=${hashJobId}#description`} className="j-tab">Description</a></Col>
            </Row>
            <JobHighlights job={job}/>
            <JobMoreInfo job={job}/>
            <JobDescription role={job?.role}/>
        </div> : <center style={{marginTop: 30}}><Spinner /></center>
    )
}
